import type { App } from "vue";
import FloatingVue from "floating-vue";

export default {
  install(app: App) {
    app.use(FloatingVue);
  },
};
